// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 786px) {\n  select {\n    width: 100%; }\n  select, option {\n    width: 100%; }\n  .mbottom {\n    margin-bottom: 21px; } }\n\n.Creationsubmited_btn {\n  background-color: #213046 !important;\n  font-size: 12px !important;\n  color: #ffffff;\n  padding: 6px 12px;\n  border-radius: 5px; }\n", ""]);
// Exports
module.exports = exports;
